import { useEffect } from "react"
import { NextRouter } from "next/router"
import {
    allRoutesV4,
    currentPathOrDefault,
    getFromQuery,
    NormalQueryParam,
    RoutePathV4,
} from "../../../_common/routing"

const MANDATORY_PARAMS_BY_PATH: Record<RoutePathV4, NormalQueryParam[]> = {
    "": [],
    category: [],
    fare: ["suite"],
    "send-quote": ["fare", "suite"],
    "guests-info": ["fare", "suite", "suite-number"],
    payment: ["checkout"],
    "thank-you": [],
    "modal-quote-thank-you": [],
    "send-quote-thank-you": [],
    "thank-you-courtesy-hold": [],
}

const hasAllMandatoryParams = (
    mandatoryParamsByPath: Record<RoutePathV4, NormalQueryParam[]>,
    router: NextRouter,
): boolean => {
    const currentPath = currentPathOrDefault(router, allRoutesV4(), "")
    const params = mandatoryParamsByPath[currentPath]
    return params.every((p) => !!getFromQuery(router, p))
}

// NOTE: useCheckUrlParams does not redirect anymore. It caused race conditions with
//  useStateToUrl because of the async nature of router.push().
export const useCheckUrlParamsV4 = (router: NextRouter) => {
    useEffect(() => {
        const id = setTimeout(() => {
            if (hasAllMandatoryParams(MANDATORY_PARAMS_BY_PATH, router)) return

            // goto(router, routeV3(""))
            console.error("Invalid query string for the current step")
        }, 500)

        return () => clearTimeout(id)
    }, [router, router.query, router.pathname])
}
